module.exports = __webpack_public_path__ + "img/rbsistemawelfare-bg.c7ca627c.png";